<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="6"
          md="5"
          class="d-none d-sm-flex"
        >
          <search-field
            :search-key-options="searchKeyOptions"
            :search-key="searchKey"  
            :search-text="searchText"
            :status="status"
            @statusChange="changeStatus"
            @search="onSearch"
            @onSearchKeyChange="onSearchKeyChange"
          />
          <version-filter
            pos-version="posVersion"
            @search="onVersionChange"
          />
        </v-col>
        <v-col
          xs="12"
          sm="6"
          md="7"
          align="end"
          class="d-none d-flex justify-end align-center"
        >
          <v-btn
            color="primary"
            class="mr-3 elevation-0"
            @click="ExportPosStoreList()"
          >
            <v-icon>mdi-cloud-download</v-icon>
          </v-btn>
          <SearchById @submit="getStore" />
          <v-btn
            id="menu_item_refresh"
            color="primary"
            :loading="loader"
            class="mr-2 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-app-bar>  
    <v-card
      flat
      outlined
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <search-field
              :search-key-options="searchKeyOptions"
              :search-key="searchKey"
              :search-text="searchText"
              :status="status"
              @statusChange="changeStatus"
              @search="onSearch"
              @onSearchKeyChange="onSearchKeyChange"
            />
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-divider></v-divider>
        </v-row> -->
        <v-row>
          <v-col
            xs="12"
            class="pa-0"
          >
            <v-data-table
              :headers="headers"
              :items="stores"
              :items-per-page="limit"
              :loading="loader"
              hide-default-footer
              mobile-breakpoint="0"
            >
              <template v-slot:[`item.id`]="{ item }">
                <v-icon small>
                  mdi-pound
                </v-icon>
                {{ item.id }}
              </template>
              <template v-slot:[`item.name`]="{ item }">
                <span
                  class="action"
                  @click="viewStore(item)"
                >{{ item.name }}</span>
                <v-icon
                  x-small
                  right
                  :color="item.live ? 'success' : 'warning'"
                >
                  mdi-circle
                </v-icon>
              </template>
              <template v-slot:[`item.account.name`]="{ item }">
                <span
                  class="action"
                  @click="viewAccount(item)"
                >{{ item.account.name }}</span><span>&nbsp;(<v-icon small>
                  mdi-pound
                </v-icon>{{ item.accountId }})</span>
              </template>
              <template v-slot:[`item.activeStatus`]="{ item }">
                <v-chip
                  label
                  :color="item.activeStatus ? 'success' : 'error'"
                >
                  {{ item.activeStatus ? "Active" : "In-active" }}
                </v-chip>
              </template>

              <template v-slot:[`item.whatsapp`]="{ item }">
                <span>
                  <template v-if="!item.whatsapp || !item.whatsapp.org_id">
                    <whatsapp-group-list
                      :chat-groups="chatGroups"
                      :stores="item"
                      @refresh="refresh"
                      @getChatGroups="getChatGroups"
                    />
                  </template>
                  <template v-else>
                    <div class="d-flex align-center justify-center text-center">
                      <v-avatar
                        size="32"
                        class="mr-2"
                        color="primary"
                      >
                        <v-img :src="item.whatsapp.chat_image" />
                      </v-avatar>
    
                      <div class="d-flex flex-column">
                        <div class="font-weight-medium text-left">
                          {{ item.whatsapp.chat_name }}
                        </div>
                        <div class="text-caption grey--text text-left">
                          {{ item.whatsapp.chat_id }}
                        </div>
                      </div>
                    </div>
                  </template>
                </span>                   
              </template>  
              <template v-slot:[`item.options`]="{ item }">
                <store-options
                  :store="item"
                  @reload="reload"
                />
              </template>
            </v-data-table>
          </v-col>    
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              :total-visible="7"
              @input="getStores()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { failure, pagination } from "@/mixins/common";
import SearchField from "@/components/utils/SearchField";
import StoreOptions from "@/components/store/StoreOptions";
import VersionFilter from "@/components/posServers/VersionFilter";
import SearchById from "@/components/utils/SearchById.vue";
import whatsappGroupList from "./whatsappGroupList.vue";
import exportReport from "@/mixins/report";

export default {
  name: "Stores",
  components: {
    SearchField,
    VersionFilter,
    StoreOptions,
    SearchById,
    whatsappGroupList
  },
  mixins: [failure, pagination, exportReport],
  data() {
    return {
      loader: false,
      headers: [
        { text: "Id", value: "id", align: "start", sortable: false },
        { text: "Name", value: "name", align: "start", sortable: false },
        { text: "Account Name", value: "account.name", sortable: false },
        { text: "Server Name", value: "posServer.name", sortable: false },
        { text: "Pos Version", value: "posServer.posVersion", align: "center", sortable: false },
        // { text: "WhatsApp", value: "whatsapp",align: "center",sortable: false },
        { text: "Status", value: "activeStatus", align: "center", sortable: false },
        { text: "", value: "options", align: "end", sortable: false }
      ],
      stores: [],
      searchKeyOptions: [
        {id: "store.name", name: "Store"},
        {id: "account.name", name: "Account"},
        {id: "pos_server.name", name: "Server"}
      ],
      sortKey: "store.name",
      searchKey: "store.name",
      searchText: null,
      posVersion:"",
      page: 1,
      totalPage: 0,
      status: "1",
      chatGroups:[]
    };
  },
  created() {
    this.init();
  },
  methods: {
    getStores() {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/stores?page=${
        this.page - 1
      }&search_key=${this.searchKey}&sort_key=${this.sortKey}&limit=${this.limit}&status=${this.status}`;
      if (this.searchText) {
        url += `&search=${this.searchText}`;
      }
      if (this.posVersion) {
        url += `&pos_version=${this.posVersion}`;
      }
      this.$http.get(url).then(
        (res) => {
          this.stores = res.body.data || [];
          this.totalPage = res.body.totalPage;
          this.page = res.body.pagination.page + 1;
          this.loader = false;
        },
        (failure) => {
          this.handleFailure(failure);
        }
      );
    },
    search() {
      this.page = 1;
      this.getStores();
    },
    reload() {
      this.searchText = null;
      this.status = "1";
      this.search();
    },
    onVersionChange(val) {
      this.posVersion = val;
      if (!val || val === "-" || val.length >= 4) {
        this.search();
      }
    },
    onSearch(val) {
      this.searchText = val;
      if (!val || val.length >= 3) {
        this.search();
      }
    },
    onSearchKeyChange(val) {
      this.searchKey = val;
      this.reload();
    },
    changeStatus(status) {
      this.status = status;
      this.search();
    },
    init() {
      this.$store.commit("setTitle", "Stores");
      this.getStores();
      // this.getChatGroups();
    },
    viewStore(store) {
      this.$router.push({
        name: "storeInfo",
        params: {
          accountId: store.accountId,
          storeId: store.id
        }
      });
    },
    viewAccount(store) {
      this.$router.push({
        name: "accountInfo",
        params: {
          accountId: store.accountId
        }
      });
    },
    getStore({id}) {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/stores/${id}`;
      this.$http.get(url).then(
        (res) => {
          this.viewStore(res.body);
        },
        (failure) => {
          this.handleFailure(failure);
          this.loader = false;
        }
      );
    },
    getChatGroups(){
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/periscope/chatGroups`;
        this.$http.get(url).then(
        (res) => {
          this.loader = false;
          this.chatGroups = res.body || [];
        },
        failure => {
          this.loader = false;
          this.handleFailure(failure);
        }   
      );
    },
    refresh(){
      this.getStores();
    },
    ExportPosStoreList() {
      let url = `${this.ADMIN_API_URL}/export/stores`;
      this.exportReport(url, ".csv", "Pos_store_list");
    }
  }
};
</script>

<style scoped>
.action {
  text-decoration: underline;
  cursor: pointer;
}

</style>
